<div class="sortControl" (clickOutside)="close()">
  <button
    #trigger
    type="button"
    class="sortTrigger"
    [class.is-open]="isOpen"
    [attr.aria-expanded]="isOpen"
    [attr.aria-controls]="isOpen ? panelId : null"
    aria-haspopup="menu"
    (click)="toggle()"
    (keydown.arrowDown)="openFromKeyboard($event)"
    (keydown.arrowUp)="openFromKeyboard($event)"
  >
    <span class="sortTrigger__icon">
      <span class="bk-sym" aria-hidden="true">{{ triggerIcon }}</span>
    </span>
    <span class="sortTrigger__text">
      <span class="sortTrigger__label">{{ label }}</span>
      @if (selectedTitle) {
        <span class="sortTrigger__value">{{ selectedTitle }}</span>
      }
    </span>
    <span class="bk-sym sortTrigger__chevron" aria-hidden="true">expand_more</span>
  </button>

  @if (isOpen) {
    <div
      class="sortPanel"
      role="menu"
      [id]="panelId"
      [attr.aria-label]="label"
      [class.align-right]="panelAlign === 'right'"
      [style.width]="panelWidth"
      (keydown)="onPanelKeydown($event)"
    >
      @for (group of groups; track group.label) {
        <div class="sortPanel__group" role="group" [attr.aria-label]="group.label">
          <p class="sortPanel__heading" aria-hidden="true">{{ group.label }}</p>
          @for (option of group.options; track option.value) {
            <button
              type="button"
              role="menuitemradio"
              tabindex="-1"
              [attr.aria-checked]="selectedValue === option.value"
              class="sortPanel__option"
              [class.is-active]="selectedValue === option.value"
              (click)="select(option.value)"
            >
              <span class="sortPanel__optionIcon">
                <span class="bk-sym" aria-hidden="true">{{ option.icon }}</span>
              </span>
              <span class="sortPanel__optionTitle">{{ option.title }}</span>
              @if (selectedValue === option.value) {
                <span class="bk-sym sortPanel__check" aria-hidden="true">check_circle</span>
              }
            </button>
          }
        </div>
      }
    </div>
  }
</div>
